import { createSelector } from 'selectors'

import { constant } from './tab.constant'

const { selector } = constant

export const getHandlersContainers = () => createSelector<NodeListOf<HTMLElement>>({ selector: selector.handler }, true)

export const getContainer = (scope: HTMLElement) => createSelector<HTMLElement>({ selector: selector.container, scope })
